module.exports = [
  "Gewerbe",
  "Büro / Praxis / Ausstellungsräume",
  "Büro/Praxen",
  "Atelier",
  "Loft",
  "Büro",
  "Büroetage",
  "Bürozentrum",
  "Bürohaus",
  "Büro& Lagergebäude",
  "Büro- u. Geschäftsgebäude",
  "Büro- und Geschäftsgebäude",
  "Büro- und Praxisflächen",
  "Praxis",
  "Praxisetage",
  "Praxishaus",
  "Wohn- u. Geschäftsgebäude",
  "Bürofläche",
  "Gewerbeflächen",
];



// WEBPACK FOOTER //
// ./src/data/buero_praxis.js